import { useAppDispatch } from "../../../../../../app/redux/hooks";
import {
  deleteAddressAsync,
  getAddressListAsync,
} from "../../../../../../app/slices/addressSlice/ProfileSlice";
import { showSnackbar } from "../../../../../../app/slices/common/customSnackBar/customSnackbarSlice";
import CustomButton from "../../../../../components/custom/button";

export const DeleteAddress = ({ type, modalClose, addressId }: any) => {
  const dispatch = useAppDispatch();

  const deleteAddres = () => {
    dispatch(deleteAddressAsync(addressId))
      .then((response: any) => {
        if (response?.payload?.status === 200) {
          dispatch(
            showSnackbar({
              message: "Address deleted successfuly.",
              severity: "success",
              autoHide: 2000,
            })
          );
          dispatch(getAddressListAsync());
          modalClose();
        } else {
          dispatch(
            showSnackbar({
              message: "Somthing went wrong, Please try again later.",
              severity: "error",
              autoHide: 2000,
            })
          );
        }
      })
      .catch((err) => {
        dispatch(
          showSnackbar({
            message: "Somthing went wrong, Please try again later.",
            severity: "error",
            autoHide: 2000,
          })
        );
      });
  };
  return (
    <>
      <div className="row">
        <div className="col-12">
          <p>
            {`Are you sure want to delete this `}
            <span style={{ fontWeight: "bold", color: "#ff0000" }}>{type}</span>
            {` address?`}
          </p>
        </div>
      </div>
      <hr />
      <div className="row">
        <div className="col-md-4"></div>
        <div className="col-md-8">
          <div className="row">
            <div className="col-md-6">
              <CustomButton
                name="Cancel"
                onClick={modalClose}
                color="secondary"
                fullWidth
              />
            </div>
            <div className="col-md-6">
              <CustomButton
                name="Delete"
                onClick={deleteAddres}
                fullWidth
                color="error"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
